import { render, staticRenderFns } from "./ChangeLogComponent.vue?vue&type=template&id=0b5a9818&"
import script from "./ChangeLogComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeLogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports